export type PlayerId =
  | 'lisa'
  | 'chuck'
  | 'michael'
  | 'dave'
  | 'steven'
  | 'robert'
  | 'shaun';

export interface Player {
  id: PlayerId;
  firstName: string;
}

export const PLAYERS: readonly Player[] = [
  { id: 'lisa', firstName: 'Lisa' },
  { id: 'chuck', firstName: 'Chuck' },
  { id: 'michael', firstName: 'Michael' },
  { id: 'dave', firstName: 'Dave' },
  { id: 'steven', firstName: 'Steven' },
  { id: 'robert', firstName: 'Robert' },
  { id: 'shaun', firstName: 'Shaun' },
] as const;

export const PLAYER_IDS: readonly PlayerId[] = PLAYERS.map((p) => p.id);

export function playerFirstName(id: PlayerId): string {
  return PLAYERS.find((p) => p.id === id)?.firstName ?? id;
}
